// todo: move to constructor

const config = {
  fixedReceiveDelta: 1 / 60,
  fixedSendDelta: 1 / 15,
  interpolate: 400,
};

export default config;
